import {
  Checkbox,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import NoDataAvailable from '../common/NoDataAvailable';
import parse from 'html-react-parser';
import request from 'src/utils/request';
import PolicyCompareQcRemarks from './PolicyCompareQcRemarks';

function OfferClauseAndCoverage({
  modouleDetail,
  qcRemarkOfEachSections,
  clauseAndCoverageData,
  coverageNoDataDetails,
  clauseNoDataDetails,
  serialNumberCoverage,
  serialNumberClause,
  setRemarksRefreshKey,
  checkAllModuleIsVerified,
  setQcRemarkOfEachSections,
  policyDetail
}) {

  const getItemId = (item) => item?.insurenceClause?.id ?? item?.id;
  const normalizeRemark = (val) => (typeof val === 'string' ? val : '');

  const [coverageData, setCoverageData] = useState([]);
  const [clauseData, setClauseData] = useState([]);

  const findCoverageObj = (id) =>
    coverageData.find(x => getItemId(x) === id) || null;

  const findClauseObj = (id) =>
    clauseData.find(x => getItemId(x) === id) || null;

  const saveQc = async (data) => {
    await request({
      url: 'endorsement/updateEndorsementQcData',
      method: 'POST',
      data: { id: modouleDetail.id, qcData: data }
    });
    setRemarksRefreshKey(k => k + 1);
    // checkAllModuleIsVerified();
  };

  useEffect(() => {
    if (!clauseAndCoverageData?.length) return;

    const coverages = [];
    const clauses = [];

    clauseAndCoverageData.forEach(item => {
      if (item.insurenceClause?.type === 'coverage') coverages.push(item);
      if (item.insurenceClause?.type === 'clause') clauses.push(item);
    });

    setCoverageData(coverages);
    setClauseData(clauses);

    setQcRemarkOfEachSections(prev => {
      const selectedCoverageIds = prev.coverages_requested?.selected_coverages || [];
      const selectedClauseIds = prev.clauses_requested?.selected_clauses || [];

      const filteredCoverages = coverages.filter(
        (item) => !selectedCoverageIds.includes(getItemId(item))
      );

      const filteredClauses = clauses.filter(
        (item) => !selectedClauseIds.includes(getItemId(item))
      );

      return {
        ...prev,

        coverages_requested: {
          ...prev.coverages_requested,
          selected_coverages: selectedCoverageIds,
          unSelected_coverages: filteredCoverages.map(getItemId),
          selected_coverage_list: [],
          unSelected_coverage_list: filteredCoverages
        },

        clauses_requested: {
          ...prev.clauses_requested,
          selected_clauses: selectedClauseIds,
          unSelected_clauses: filteredClauses.map(getItemId),
          selected_clauses_list: [],
          unSelected_clauses_list: filteredClauses
        }
      };
    });

  }, [clauseAndCoverageData]);

  const updateStatus = (sectionKey, unKey, remarkKey, msg) => {
    setQcRemarkOfEachSections(prev => {
      const unSelected = prev?.[sectionKey]?.[unKey] || [];
      const remark = normalizeRemark(prev?.[sectionKey]?.[remarkKey]);
      const status = unSelected.length ? 'endorsement_required' : 'approve';

      const updated = {
        ...prev,
        [sectionKey]: {
          ...prev[sectionKey],
          status,
          [remarkKey]: unSelected.length && !remark.trim() ? msg : remark
        }
      };

      saveQc(updated);
      return updated;
    });
  };

  const syncSelection = (
    section,
    selKey,
    unKey,
    listSelKey,
    listUnKey,
    id,
    allIds,
    remarkKey,
    msg
  ) => {
    setQcRemarkOfEachSections(prev => {

      const selected = prev?.[section]?.[selKey] || [];
      const isSelected = selected.includes(id);

      const nextSelected = isSelected
        ? selected.filter(x => x !== id)
        : [...selected, id];

      const nextUnSelected =
        nextSelected.length === 0
          ? allIds
          : nextSelected.length === allIds.length
            ? []
            : allIds.filter(x => !nextSelected.includes(x));

      const nextSelectedList =
        section === 'coverages_requested'
          ? nextSelected.map(findCoverageObj).filter(Boolean)
          : nextSelected.map(findClauseObj).filter(Boolean);

      const nextUnSelectedList =
        section === 'coverages_requested'
          ? nextUnSelected.map(findCoverageObj).filter(Boolean)
          : nextUnSelected.map(findClauseObj).filter(Boolean);

      const updated = {
        ...prev,
        [section]: {
          ...prev[section],
          [selKey]: nextSelected,
          [unKey]: nextUnSelected,
          [listSelKey]: nextSelectedList,
          [listUnKey]: nextUnSelectedList
        }
      };

      saveQc(updated);

      setTimeout(() => updateStatus(section, unKey, remarkKey, msg), 0);
      return updated;
    });
  };

  return (
    <>
      <div style={{ background: '#0954AE', color: '#fff', padding: 6, textAlign: 'center' }}>Coverages Requested</div>
      <Grid container

        style={{
          opacity: (
            policyDetail?.parentqcData ||
            policyDetail?.insurancePolicy?.qcData
          )?.coverages_requested?.status === 'approve'
            ? 0.5
            : 1,
          pointerEvents:
            (
              policyDetail?.parentqcData ||
              policyDetail?.insurancePolicy?.qcData
            )?.coverages_requested?.status === 'approve'
              ? 'none'
              : 'auto',
        }}
      >
        <TableContainer component={Paper} sx={{ mt: 2, mx: 3 }}>
          {coverageNoDataDetails.length ? (
            <Table size="small">
              <TableHead sx={{ background: '#e8f5e9' }}>
                <TableRow>
                  <TableCell width={82} style={{ paddingRight: '0px' }}>Sl.No</TableCell>
                  <TableCell>Coverage</TableCell>
                  <TableCell>Premium</TableCell>
                  <TableCell>Additional Remarks</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {coverageData.map((c, i) => {
                  const id = getItemId(c);
                  const checked = qcRemarkOfEachSections?.coverages_requested?.selected_coverages?.includes(id);
                  return (
                    <TableRow key={id}>
                      <TableCell style={{ paddingRight: '0px' }}>
                        <span style={{ display: 'inline-block', width: '25px' }}>  {serialNumberCoverage + i}</span>

                        <Checkbox size="small" checked={checked}
                          onChange={() => syncSelection(
                            'coverages_requested',
                            'selected_coverages',
                            'unSelected_coverages',
                            'selected_coverage_list',
                            'unSelected_coverage_list',
                            id,
                            coverageData.map(getItemId),
                            'remarks',
                            'Missing Coverages'
                          )}
                        />
                      </TableCell>
                      <TableCell>{parse(c.insurenceClause?.title || '')} <br />
                        {parse(c.insurenceClause?.detailDescription || '')}
                      </TableCell>
                      <TableCell>{c.premium || 'N/A'}</TableCell>
                      <TableCell>{c.remarks || 'N/A'}</TableCell>
                    </TableRow>
                  );
                })}
                <TableRow>
                  <TableCell colSpan={4}>
                    <PolicyCompareQcRemarks
                      modouleDetail={policyDetail}
                      qcRemarkOfEachSections={qcRemarkOfEachSections}
                      section_key="coverages_requested"
                      block_key=""
                      checkAllModuleIsVerified={checkAllModuleIsVerified}
                      setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          ) : <NoDataAvailable />}
        </TableContainer>
      </Grid>

      <div style={{ background: '#0954AE', color: '#fff', padding: 6, textAlign: 'center', marginTop: 10 }}>Clauses Requested</div>
      <Grid container
        style={{
          opacity: (
            policyDetail?.parentqcData ||
            policyDetail?.insurancePolicy?.qcData
          )?.clauses_requested?.status === 'approve'
            ? 0.5
            : 1,
          pointerEvents: (
            policyDetail?.parentqcData ||
            policyDetail?.insurancePolicy?.qcData
          )?.clauses_requested?.status === 'approve'
            ? 'none'
            : 'auto',
        }}
      >
        <TableContainer component={Paper} sx={{ mt: 2, mx: 3 }}>
          {clauseNoDataDetails.length ? (
            <Table size="small">
              <TableHead sx={{ background: '#e8f5e9' }}>
                <TableRow>
                  <TableCell width={82} style={{ paddingRight: '0px' }}>Sl.No</TableCell>
                  <TableCell>Clause</TableCell>
                  <TableCell>Additional Remarks</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {clauseData.map((c, i) => {
                  const id = getItemId(c);
                  const checked = qcRemarkOfEachSections?.clauses_requested?.selected_clauses?.includes(id);
                  return (
                    <TableRow key={id}>
                      <TableCell style={{ paddingRight: '0px' }}>
                        <span style={{ display: 'inline-block', width: '25px' }}>  {serialNumberClause + i}</span>

                        <Checkbox size="small" checked={checked}
                          onChange={() => syncSelection(
                            'clauses_requested',
                            'selected_clauses',
                            'unSelected_clauses',
                            'selected_clauses_list',
                            'unSelected_clauses_list',
                            id,
                            clauseData.map(getItemId),
                            'remarks',
                            'Missing Clauses'
                          )}
                        />
                      </TableCell>
                      <TableCell>{parse(c.insurenceClause?.title || '')} <br />
                        {parse(c.insurenceClause?.detailDescription || '')}
                      </TableCell>
                      <TableCell>{c.remarks || 'N/A'}</TableCell>
                    </TableRow>
                  );
                })}
                <TableRow>
                  <TableCell colSpan={3}>
                    <PolicyCompareQcRemarks
                      modouleDetail={policyDetail}
                      qcRemarkOfEachSections={qcRemarkOfEachSections}
                      section_key="clauses_requested"
                      block_key=""
                      checkAllModuleIsVerified={checkAllModuleIsVerified}
                      setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          ) : <NoDataAvailable />}
        </TableContainer>
      </Grid>
    </>
  );
}

export default OfferClauseAndCoverage;
